import dispatchActions from 'Services/dispatchActions'

export default {
  beforeCreate: function () {
    const actionList = window['vuexActions'] || []

    dispatchActions(this.$store, actionList)
  }
}